module.exports = __webpack_public_path__ + "img/IMG_1627_WoodMatted.bbdd3f0e.jpg";